module.exports = __webpack_public_path__ + "img/title-m.2612dfd6.svg";